import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../src/component/Header';
import IconPen from '../../../src/component/SvgIcons/IconPen';
import IconUpdownFilter from '../../../src/component/SvgIcons/IconUpdownFilter';
import Pagination from '../../component/Pagination';
import IconSearch from '../../component/SvgIcons/IconSearch';
import api from '../../Services/api';
import '../Events/style.css';
import { Tooltip } from 'react-tooltip';

import { formatCountryDate } from "../../Services/countryTime";
export default function RenewalLicense() {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCountry, setSelectedCountry] = useState("All Countries"); // Default to India
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [itemsPerPage, setItemsPerPage] = useState(10);  
    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth >= 1920) {
          setItemsPerPage(20);
        } else {
          setItemsPerPage(10);
        }
      };
      handleResize(); // Set initial value
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);


  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await api.post('/getAllRenewal');
      console.log('API Response getAllRenewal:', response.data);
      
      if (response.data.success) {
        const formattedData = response.data.data.map(item => ({
          id: item.id,
          DateTime: item.DateTime,
          CountryName: item.country,
          ProductName: item.product_name,
          Pricing: item.price,
        }));
        setUsers(formattedData);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedUsers = [...users].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  // Extract unique country names for dropdown
  const countryOptions = [...new Set(users.map(user => user.CountryName))];

  const filteredRenewal = sortedUsers.filter(user => {
    const formattedDate = new Date(user.DateTime).toISOString().split('T')[0]; // Format to YYYY-MM-DD
    return (
      (selectedCountry === 'All Countries' || user.CountryName === selectedCountry) &&
      (formattedDate.includes(searchQuery) || // Match date
        user.CountryName.toLowerCase().includes(searchQuery.toLowerCase()) || 
        user.Pricing.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  });
  

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredRenewal.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredRenewal.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <section className='eventpage'>
      <Header pageTitle="Renewal Licence Price List" backTo="/new-licence" />
      <div className='pageLeftspace'>

      <div className="d-flex justify-content-between align-items-center topsearchbar">
      <div className="d-flex align-items-center gap-2">
            {/* Country Dropdown */}
            <select
              className="form-select"
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
            >
              <option value="All Countries">All Countries</option>
              {countryOptions.map((country, index) => (
                <option key={index} value={country}>
                  {country}
                </option>
              ))}
            </select>

             <Link to="#" onClick={() => handleSort("Pricing")}>
              <IconUpdownFilter />
            </Link> 
            </div>

            {/* Search Box */}
            <div className="input-container">
              <input
                type="text"
                id="name"
                value={searchQuery}
                onChange={handleSearchChange}
               placeholder="Search Here.."
              />
               <div className="search-icon">
                <IconSearch/>
              </div>
              <span className="underline"></span>
            </div>
          </div>

        <div className="tableheader d-flex flex-column gap-4">
          {/* Table */}
          <div className='event-detailstable'>
            <table className="table">
              <thead>
                <tr>
                <th width="10px" align="center">Sr. No.</th>
                  <th>Date</th>
                  <th>Country Name</th>
                  <th>Product Name</th>
                  <th>Pricing</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.length > 0 ? (
                  currentUsers.map((user, index) => (
                    <tr key={user.id}>
                      <td align="center">{index + 1}</td>                                          
                     <td>
                       {formatCountryDate(user.DateTime).replace(/\//g, "-")}
                      </td>
                      <td>{user.CountryName}</td>
                      <td>{user.ProductName}</td>
                      <td>{user.Pricing}</td>
                      <td>
                        <Link  to={`/edit-renewal/${user.id}`}  className="action" style={{ display: "block" }}
                        data-tooltip-id={`edit-${user.id}`}
                        data-tooltip-content="Edit"><IconPen /></Link>   
                         <Tooltip id={`edit-${user.id}`} place="top" />                     
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center", padding: "10px" }}>
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <Pagination
            currentPage={currentPage}
            totalPages={filteredRenewal.length > itemsPerPage ? totalPages : 0}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}
